const NO_LAST_NAME_LETTER = "#";

// `#` leads instead of trailing: the server collates an absent last name to "",
// which orders before every letter, so trailing it would break rail monotonicity.
export const DIRECTORY_INDEX_LETTERS: readonly string[] = [
  NO_LAST_NAME_LETTER,
  ...Array.from({ length: 26 }, (_, index) =>
    String.fromCharCode("A".charCodeAt(0) + index),
  ),
];

// Mirrors the options of the comparator the server sorts by
// (user-identity.schemas.ts), whose collator is module-private and cannot be reused.
const letterCollator = new Intl.Collator(undefined, { sensitivity: "base" });

export function resolveDirectoryLetter(lastName: string | null): string {
  // Not a fallback bucket: the server compares `lastName ?? ""`, so these rows
  // really are the ones it sorted above every letter.
  if (lastName === null || lastName.trim() === "") {
    return NO_LAST_NAME_LETTER;
  }

  // Descends to index 1: index 0 is `#`, which is the fallthrough, not a match.
  for (let index = DIRECTORY_INDEX_LETTERS.length - 1; index >= 1; index -= 1) {
    const letter = DIRECTORY_INDEX_LETTERS[index];
    if (letter !== undefined && letterCollator.compare(lastName, letter) >= 0) {
      return letter;
    }
  }

  return NO_LAST_NAME_LETTER;
}
